const mergeFunctionCalls = (...functions) => () => {
  for (const fn of functions) {
    if (fn === void 0 || fn === null)
      continue;
    fn();
  }
};
const normalizeCTKDuplicate = (activityId = "") => {
  activityId = activityId.replace("pretest-", "");
  if (activityId.includes("#")) {
    const normalizedCTKDuplicate = activityId.split("#");
    return normalizedCTKDuplicate[1];
  } else {
    return activityId;
  }
};
const encodeId = (id = "") => {
  return id.replace(/#/g, encodeURIComponent("#"));
};
export {
  encodeId,
  mergeFunctionCalls,
  normalizeCTKDuplicate
};
